import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { ICompromissosDisponiveis } from "../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";

interface IDescricaoEventoAgendamentoProps {
    compromissos: ICompromissosDisponiveis;
}

export default function DescricaoEventoDisponivelVistoria(
    props: IDescricaoEventoAgendamentoProps
) {
    return (
        <div>
            <div className="w-100 d-flex align-items-center justify-content-between font-weight-bolder font-size-h4">
                Horário disponível:{" "}
                {moment(props.compromissos?.DT_INICIO).format("HH:mm")} -{" "}
                {moment(props.compromissos?.DT_FIM).format("HH:mm")}
                <span className="label label label-primary"></span>
            </div>
            <hr />
            <div className="my-2">
                <div className="d-flex flex-row g-2 align-items-center">
                    <span className="rounded-circle bg-light-info text-info p-2 d-inline-flex align-items-center justify-content-center mr-2 my-1">
                        <FontAwesomeIcon icon={faHome} />
                    </span>
                    <span>{props.compromissos?.DS_PRODUTO}</span>
                </div>
            </div>
            <hr />
        </div>
    );
}
